var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"title"},[_vm._v("数据统计📊")]),_c('Hits'),_c('div',{staticClass:"click-all"},[_c('clickNum'),_c('api-in-dash')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }